require('@adc/logger').forModule('BOOTSTRAP').info('Loaded polyfills')

require('core-js/stable')
require('regenerator-runtime/runtime')
require('intersection-observer')

/**
 *  NOTE: This is temporary and is only here to support IE11 for the next 30 days with the new webpack config. The
 *  problem is that between this polfill and actions in the browser, some code elsewhere is clobbering the polyfill and
 *  replacing it with it's own implementation that doesn't support all the methods we require.
 *
 *  We will remove this in the next major release to make sure we keep backwards compat with any apps that have already
 *  integrated in this hack.
 *
 */
window.__adc_polyfill_objects__ = {
  Promise: window.Promise,
}
